import { Alert, Button, Text } from '@payaca/ambrosia';
import { FC, ReactNode } from 'react';

/** Inspector tab for inverter units and strings. */
const ElectricalTab: FC<{
  geometryMode: boolean;
  /** The allocation editor, once the design has electrical allocation. */
  allocation?: ReactNode;
  /** Absent when the selected inverter cannot take string allocation. */
  onConfigure?: () => void;
  /** Starts roof drawing when the design has no roof model yet. */
  onDrawRoof?: () => void;
  /** Opens Equipment when the selected inverter cannot take strings. */
  onChooseInverter?: () => void;
  layoutChangeDisabledReason?: string;
  /** The last rejected allocation or configuration change. */
  error?: string | null;
}> = ({
  geometryMode,
  allocation,
  onConfigure,
  onDrawRoof,
  onChooseInverter,
  layoutChangeDisabledReason,
  error,
}) => {
  const alert = error && (
    <Alert colour="yellow">
      <Text>{error}</Text>
    </Alert>
  );
  if (!geometryMode)
    return onDrawRoof ? <Button onClick={onDrawRoof}>Draw roof</Button> : null;
  if (allocation)
    return (
      <div className="space-y-4">
        {alert}
        {allocation}
      </div>
    );
  if (!onConfigure)
    return onChooseInverter ? (
      <Button onClick={onChooseInverter}>Choose inverter</Button>
    ) : null;
  return (
    <div className="space-y-3">
      {alert}
      <Button
        onClick={onConfigure}
        disabled={!!layoutChangeDisabledReason}
        aria-describedby={
          layoutChangeDisabledReason
            ? 'allocation-configuration-guidance'
            : undefined
        }
      >
        Auto-string
      </Button>
      {layoutChangeDisabledReason && (
        <Text id="allocation-configuration-guidance" level="supporting">
          {layoutChangeDisabledReason}
        </Text>
      )}
    </div>
  );
};

export default ElectricalTab;
